// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__18HIZ","fileBtn":"File_fileBtn__1ECam","closeBtn":"File_closeBtn__2NEng","fileSelected":"File_fileSelected__3t_hN","disabled":"File_disabled__1S7ji"};